import { StandardToolResult } from '../types/standardToolResults';
import { CommandExecutionContext } from '../types/commands';
import fetchService from '../services/fetchService';
import { API_BASE_URL } from '../api/config';

export async function callToolRuntime(
  toolName: string,
  params: any,
  context: CommandExecutionContext
): Promise<StandardToolResult> {
  const spaceId = context.spaceId;

  return fetchService(`${API_BASE_URL}/tools/execute`, {
    method: 'POST',
    body: JSON.stringify({ toolName, params, spaceId }),
  });
}
